import {
  Condition,
  Trigger,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import { SceneWizardStepEnum } from '../SceneWizardStep';

@Options({
  name: 'SceneTriggerAndConditionGeneral',
  props: {
    triggerOrActionToAdd: {
      type: Object as PropType<Trigger | Condition>,
    },
    stepToAdd: {
      required: true,
      type: Number,
    },
    confirmDisabled: {
      required: false,
      type: Boolean,
    },
  },
  watch: {
    isConfirmEnabled: function () {
      this.emitDisabled();
    },
  },
  emits: ['confirm-disabled'],
})
export default class SceneTriggerAndConditionGeneral extends Vue {
  triggerOrActionToAdd!: Trigger | Condition;
  stepToAdd!: SceneWizardStepEnum;
  confirmDisabled!: boolean;

  get isCondition() {
    return this.stepToAdd === SceneWizardStepEnum.STEP_CONDITION;
  }

  created() {
    this.emitDisabled();
  }

  emitDisabled() {
    //computed property in child classes
    this.$emit('confirm-disabled', !(this as any).isConfirmEnabled);
  }
}
